import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
    baseURL: HOST_API,
});

let isRefreshingAxios = false;
let axiosRefreshQueue = [];

axiosInstance.interceptors.response.use(
    (res) => res,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            if (isRefreshingAxios) {
                return new Promise((resolve, reject) => {
                    axiosRefreshQueue.push({ resolve, reject });
                }).then((token) => {
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    return axiosInstance(originalRequest);
                });
            }

            isRefreshingAxios = true;
            try {
                const { default: axios } = await import('axios');
                const { HOST_API } = await import('../config');
                const response = await axios.post(`${HOST_API}/api/v1/auth/token/refresh/`, {
                    refresh: localStorage.getItem('refreshToken'),
                });

                if (response.status === 200) {
                    const newAccess = response.data.access;
                    const { setSession } = await import('./jwt');
                    setSession(newAccess, localStorage.getItem('refreshToken'));

                    axiosRefreshQueue.forEach((req) => req.resolve(newAccess));
                    axiosRefreshQueue = [];
                    originalRequest.headers.Authorization = `Bearer ${newAccess}`;
                    return axiosInstance(originalRequest);
                }
                throw new Error('Refresh failed');
            } catch (refreshError) {
                const { setSession } = await import('./jwt');
                setSession(null, null);
                axiosRefreshQueue.forEach((req) => req.reject(refreshError));
                axiosRefreshQueue = [];
                if (!window.location.pathname.includes('/login')) {
                    window.location.href = '/';
                }
                return Promise.reject(refreshError);
            } finally {
                setTimeout(() => { isRefreshingAxios = false; }, 2000);
            }
        }

        return Promise.reject((error.response && error.response.data) || 'Something went wrong');
    }
);

export default axiosInstance;
